<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2024-06-28 10:02:33
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-07-26 16:33:00
 * @FilePath: /wemeet-admin-new/src/views/data/daliyReport.vue
 * @Description: 
 * Copyright (c) 2024 by WeMeet, All Rights Reserved. 
-->
<template>
  <div ref="containerRef" class="exhDataDialog">
    <el-button style="margin-bottom: 20px" @click="goBack">返回</el-button>
    <!-- -->
    <allData :data="data" :meeting-name="queryForm.meetingName" />

    <div class="title mt-20">
      渠道日报

      <div>
        <span style="font-size: 14px; color: #666">查看日期:</span>
        <el-date-picker
          v-model="timeRange"
          :disabled-date="disabledDate"
          end-placeholder="结束时间"
          range-separator="-"
          start-placeholder="开始时间"
          style="margin-left: 10px"
          type="daterange"
          @blur="handleBlur"
          @calendar-change="handleChange"
          @change="pickerChange"
          @focus="handleFocus"
        />
      </div>
    </div>

    <accSummaryVue :data="data.totalStatisticsDetailMaps" />
    <natureSummary :data="data.naturalStatisticsDetailMap" />
    <replySummaryVue :data="data.relayStatisticsDetailMaps" />
    <hostSummaryVue :data="data.hostStatisticsDetailMaps" />

    <template v-for="(item, index) in hostDetails" :key="index">
      <hostChannelVue :data="item" />
    </template>
    <!-- <el-table :data="tableData" style="width: 100%">
      <el-table-column label="渠道" width="150">
        <el-table-column prop="name" label="注册渠道" width="120" />
        <el-table-column prop="name" label="身份类型" width="120" />
      </el-table-column>
      <el-table-column label="2024-8-1">
        <el-table-column prop="name" label="Name" width="120" />
        <el-table-column prop="name" label="Name" width="120" />
        <el-table-column prop="name" label="Name" width="120" />
        <el-table-column prop="name" label="Name" width="120" />
      </el-table-column>
      <el-table-column label="2024-8-2">
        <el-table-column prop="name" label="Name" width="120" />
        <el-table-column prop="name" label="Name" width="120" />
        <el-table-column prop="name" label="Name" width="120" />
        <el-table-column prop="name" label="Name" width="120" />
      </el-table-column>
    </el-table> -->
  </div>
</template>

<script>
  import {
    defineComponent,
    onMounted,
    reactive,
    toRefs,
    onUnmounted,
    getCurrentInstance,
    onActivated,
    watch,
  } from 'vue'
  import allData from './components/daliyReport/allData.vue'
  import { reportMeetingDailyDetail } from '@/api/workBench'
  import { parseTime } from '@/utils/index'
  import { getRegisterConfigList } from '@/api/exhibitionManage'
  import accSummaryVue from './components/daliyReport/accSummary.vue'
  import natureSummary from './components/daliyReport/natureSummary.vue'
  import replySummaryVue from './components/daliyReport/replySummary.vue'
  import hostSummaryVue from './components/daliyReport/hostSummary.vue'
  import hostChannelVue from './components/daliyReport/hostChannel.vue'
  import _ from 'lodash'
  export default defineComponent({
    name: 'DataIndex',
    components: {
      allData,
      accSummaryVue,
      natureSummary,
      replySummaryVue,
      hostSummaryVue,
      hostChannelVue,
    },
    setup() {
      const { proxy } = getCurrentInstance()
      const getPreviousDay = (date) => {
        var previousDay = new Date(date)
        previousDay.setDate(previousDay.getDate() - 1)
        return previousDay
      }

      const state = reactive({
        activeName: 'first',
        containerRef: null,
        queryForm: {
          meetingCode: '',
          meetingType: '',
          identity: '',
          startTime: '',
          endTime: '',
        },

        data: [],
        identity: [],
        realData: [],
        geoDistribution: {},
        questionnaire: [],
        idenityCount: [],
        aiData: {},
        channelData: [],
        channelCodeList: [],
        exportRegisterRef: null,

        timeRange: [getPreviousDay(new Date()), new Date()],
        hostDetails: [],
      })

      const handleClick = (e) => {
        console.log(e.props.name)
        scrollBottom(e.props.name)
      }
      const scrollBottom = (id) => {
        setTimeout(() => {
          if (state.containerRef) {
            const dom = document.getElementById(id)
            console.log(dom, dom.offsetTop)
            state.containerRef.scrollTo({
              top: dom.offsetTop,
              behavior: 'smooth',
            })
          }
        }, 200)
      }
      let scrollHandler = null

      const queryStaticData = async () => {
        const { data } = await reportMeetingDailyDetail(state.queryForm)
        state.data = data
        state.data = _.cloneDeep(state.data)
        let hostDetailLists = data.hostDetailLists

        // let mergedHostDetails = hostDetailLists.reduce((accumulator, current) => {
        //   let existingItem = accumulator.findIndex(
        //     (item) => item.channelCode === current.channelCode
        //   )
        //   if (existingItem > -1) {
        //     accumulator[existingItem][`data`].push(current)
        //   } else {
        //     let ncurrent = _.cloneDeep(current)
        //     ncurrent.data = [current]
        //     accumulator.push(ncurrent)
        //   }
        //   return accumulator
        // }, [])
        // let hostDetails = []
        // for (let i of mergedHostDetails) {
        //   let obj = {
        //     name: i.channelName,
        //     data: [],
        //   }
        //   obj.data = i.data
        //   hostDetails.push(obj)
        // }
        // console.log(hostDetails, '处理过的数据')
        state.hostDetails = data.hostDetailListMaps
      }

      onMounted(() => {
        if (!proxy.$route.query.meetingCode) {
          proxy.$router.replace('/exhibitionManage/exhibitionManage')
        }
        // state.queryForm.meetingCode = proxy.$route.query.meetingCode
        // state.queryForm.meetingType = proxy.$route.query.meetingType
        // state.queryForm.meetingName = proxy.$route.query.meetingName

        // queryStaticData()
      })

      // onActivated(() => {
      //   if (!proxy.$route.query.meetingCode) {
      //     proxy.$router.replace('/exhibitionManage/exhibitionManage')
      //   }
      //   state.queryForm.meetingCode = proxy.$route.query.meetingCode
      //   state.queryForm.meetingType = proxy.$route.query.meetingType
      //   state.queryForm.meetingName = proxy.$route.query.meetingName

      //   queryStaticData()
      // })

      onUnmounted(() => {})
      const pickerChange = (val) => {
        console.log(val, '=-==')
        try {
          state.queryForm.startTime = parseTime(val[0], '{y}-{m}-{d}')
          state.queryForm.endTime = parseTime(val[1], '{y}-{m}-{d}')
          state.queryForm.pageNum = 1
          queryStaticData()
        } catch (err) {
          state.chooseDay = null
          state.timeRange = [null, null]
          state.queryForm.startTime = ''
          state.queryForm.endTime = ''
        }
      }
      //取值方法
      const handleFocus = () => {
        if (!!state.queryForm.startTime && !!state.queryForm.endTime) {
          state.chooseDay = null
        }
      }

      const handleBlur = (val) => {
        // console.log(val)
        // state.chooseDay = null
      }
      const disabledDate = (time) => {
        if (!state.chooseDay) {
          return time.getTime() >= Date.now()
        }
        let timeRange = 1
        const con1 = new Date(state.chooseDay).getTime() - timeRange * 24 * 60 * 60 * 1000
        const con2 = new Date(state.chooseDay).getTime() + timeRange * 24 * 60 * 60 * 1000
        return time < con1 || time > con2
      }

      const handleChange = (val) => {
        const [pointDay] = val
        state.chooseDay = pointDay
      }

      const goBack = () => {
        proxy.$router.go(-1)
      }

      watch(
        () => proxy.$route.query.meetingCode,
        (newVal, oldVal) => {
          console.log(newVal)
          state.queryForm.meetingCode = proxy.$route.query.meetingCode
          state.queryForm.meetingType = proxy.$route.query.meetingType
          state.queryForm.meetingName = proxy.$route.query.meetingName
          state.queryForm.aiApplicationType = proxy.$route.query.aiApplicationType

          queryStaticData()
        },
        {
          deep: true,
          immediate: true,
        }
      )

      return {
        ...toRefs(state),
        handleClick,
        pickerChange,
        handleFocus,
        disabledDate,
        handleChange,
        goBack,
        handleBlur,
      }
    },
  })
</script>

<style lang="scss">
  .exhDataDialog {
    .el-tabs__item {
      font-size: 18px;
    }
  }
</style>

<style lang="scss" scoped>
  .exhDataDialog {
    width: 100%;
    height: 83vh;
    background: #f7f8fa;
    overflow-y: auto;
    position: relative;
    .demo-tabs {
      background: #fff;
      border-radius: 10px;
      padding-left: 20px;
    }
    .title {
      font-size: 18px;
      color: #1d2129;
      font-weight: bold;
      margin-bottom: 12px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .mt-20 {
      margin-top: 20px;
    }
  }
</style>
